// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartLinesStyles } from "@guestsupply/Overrides/Widgets/Cart/CartLines";
import InfoAlert from "@guestsupply/XDL/Icons/InfoAlert";
import { avoidBreakInsidePrintElement, createLinkIconStyles, xScreen } from "@guestsupply/XDL/Utilities";
import ShoppingCart from "@insite/mobius/Icons/ShoppingCart";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

cartLinesStyles.centeringWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        height: 300px;
        justify-content: center;
        align-items: center;
    `,
};
cartLinesStyles.loadingSpinnerCenteringWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        height: 300px;
        justify-content: center;
        align-items: center;
        ${xScreen("lte", "md")} {
            position: absolute;
            width: 100%;
        }
    `,
};
cartLinesStyles.noCartLinesText = {
    variant: "h3",
};
cartLinesStyles.noCartLinesIcon = {
    src: ShoppingCart,
    size: 45,
    color: "text.link",
    css: css`
        margin-bottom: 20px;
    `,
};
cartLinesStyles.headerWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        padding-top: 20px;
        border-top: 1px solid ${getColor("common.border")};
        margin-bottom: 12px;
        ${xScreen("lte", "sm")} {
            flex-direction: column;
            padding-top: 16px;
        }
    `,
};
cartLinesStyles.header = {
    condensedViewCheckboxGroup: {
        css: css`
            margin-left: auto;
        `,
    },
    condensedViewCheckbox: {
        typographyProps: {
            css: css`
                margin-left: 10px;
            `,
        },
    },
    overflowMenu: {
        cssOverrides: {
            wrapper: css`
                margin-left: 20px;
            `,
        },
    },
    removeAllLink: {
        css: css`
            margin-left: 24px;
        `,
    },
    mainSection: {
        css: css`
            display: flex;
            align-items: center;
            padding-bottom: 5px;
        `,
    },
    warningIcon: {
        src: "AlertCircle",
        color: "danger.main",
        css: css`
            margin-right: 10px;
        `,
    },
    warningSection: {
        css: css`
            display: flex;
            align-items: center;
            border: 2px solid ${getColor("danger.main")};
            padding: 15px 10px;
        `,
    },
};
cartLinesStyles.footerWrapper = {
    css: css`
        display: flex;
        justify-content: center;
    `,
};
cartLinesStyles.backToTopButton = {
    variant: "secondary",
    css: css`
        margin: 16px 0;
    `,
};
cartLinesStyles.itemDescriptionWapper = {
    css: css`
        display: flex;
        flex-direction: column;
        ${xScreen("lte", "sm")} {
            flex-direction: row;
            justify-content: space-between;
            &.shipping-wrapper {
                flex-direction: column;
            }
        }
    `,
};
cartLinesStyles.groupsWrapper = {
    css: css`
        ${({ isCartPage }: any) => {
            if (isCartPage) {
                return css`
                    border-bottom: 1px solid ${getColor("common.border")};
                `;
            }
        }}
    `,
};
cartLinesStyles.groupWrapper = {
    css: css`
        cursor: pointer;
        ${avoidBreakInsidePrintElement}
    `,
};
cartLinesStyles.tooltipStyle = {
    cssOverrides: {
        tooltipClickable: css`
            margin-left: 0;
        `,
    },
};
cartLinesStyles.freeShippingLink = {
    ...createLinkIconStyles(InfoAlert, {
        typographyProps: {
            size: 12,
            weight: "bold",
            css: css`
                margin-left: 2px;
                line-height: 12px;
            `,
        },
        icon: {
            iconProps: {
                size: 12,
                color: "text.link",
            },
            position: "right",
        },
        css: css`
            &&& {
                display: flex;
            }
        `,
    }),
};
cartLinesStyles.groupsLinesHeaderStyles = {
    wrapper: {
        css: css`
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            border-bottom: none;
            min-height: 48px;
        `,
    },
    itemDescription: {
        css: css`
            ${xScreen("lte", "md")} {
                min-height: 48px;
            }
            ${xScreen("lte", "sm")} {
                height: initial;
            }
        `,
    },
};
cartLinesStyles.subGroupsLinesHeaderStyles = {
    wrapper: {
        css: css`
            &.first-sub-group {
                border-top-left-radius: 0;
                border-top-right-radius: 0;
                border-top-color: ${getColor("common.border")};
            }
            background-color: ${getColor("common.white")};
        `,
    },
};
cartLinesStyles.linesHeaderLabelTypography = {
    weight: 400,
    css: css`
        display: none;
        ${xScreen("lte", "md")} {
            display: block;
        }
    `,
};
cartLinesStyles.shippingHandlingTypography = {
    css: css`
        /* To override sitemessage typography style */
        ${TypographyStyle} {
            font-size: 12px;
        }
    `,
};
